import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { GlobalsStore } from '../../../stores/globals.state';
import { Story } from '../../../models/story';
import { Button, ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { TableRowAction } from '../table-row-indicator/table-row-indicator.component';
import { NgIf } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { ActiveUserStore } from '../../../stores/user/active-user.state';
import { RoutingService } from '../../../services/routing.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-table-row-story]',
  standalone: true,
  imports: [Button, ButtonDirective, RouterLink, NgIf, TooltipModule],
  templateUrl: './table-row-story.component.html',
  styleUrl: './table-row-story.component.scss',
})
export class TableRowStoryComponent {
  readonly activeUserStore = inject(ActiveUserStore);
  readonly globalStore = inject(GlobalsStore);
  @Input() item!: Story;
  @Input() actions: TableRowAction[] = [];
  @Output() closeEvent = new EventEmitter<void>();

  constructor(private routingService: RoutingService) {}
  closeParent() {
    this.closeEvent.emit();
  }

  /**
   * Opens the given story in the Atlas view. The method determines the appropriate action
   * based on the user's context. If the user context is 'dataBackend', the story is opened
   * in a new tab with the Atlas link. Otherwise, it sets the provided story as the active story.
   *
   * @param {Story} item - The story object to be opened or set as active. Must include `_id` property.
   * @return {void} This method does not return a value.
   */
  openInAtlas(item: Story): void {
    this.closeParent();
    if (this.activeUserStore.context() === 'dataBackend') {
      this.routingService.openRouteInNewTab(`/atlas-intern?story=${item._id}`);
    } else {
      this.globalStore.setActiveStory(item._id);
    }
  }
}
